import React from "react";

const ProductsCount = (props) => {

  const renderCheckUnckeckAll = () => {
    const {
      checkUncheckAllState, translations,
      onCheckAllClick, onUncheckAllClick
    } = props;

    let label, clickHandler;

    if (checkUncheckAllState == "check all") {
      label = translations.select_all
      clickHandler = onCheckAllClick;
    } else {
      label = translations.unselect_all;
      clickHandler = onUncheckAllClick;
    }

    return (
      <a
        href="#"
        onClick={clickHandler}
      >
        {label}
      </a>
    )
  }

  const { productsCount, translations } = props;
  return (
    <div>
      <span>{productsCount} {translations.products_found}</span>
      <span className="productsCount__checkUncheckAll">
        {renderCheckUnckeckAll()}
      </span>
    </div>
  )
}

export default ProductsCount;